module.exports = __webpack_public_path__ + "16b73aac6422b4d3aad6dae51c429aaf.png";